var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","plain":""},on:{"click":function($event){return _vm.$emit('click:progress-backward-item', _vm.$attrs.item)}}},'v-btn',_vm.$props,false),_vm.$listeners),[_vm._t("default",function(){return [_c('v-icon',{attrs:{"color":"orange"}},[_vm._v(_vm._s(_vm.$icons.applicantProgressBackward))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }